import React, { useEffect, useState } from "react";
import "./Address.css";
// import "./tab.css"
import Select from "react-select";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import axios from "axios";

const AddressForm = ({
  activeTab,
  formik,

  handleBillingShippingSame,
  pincodeValidationError,
  mode = "",
  isDisabled,
}) => {
  const [cityData, setCityData] = useState([]);
   const [isterms, setIsterm] = useState(false);
  const [manualEntry, setManualEntry] = useState(false);
  const handleCityChange = async (formik, value) => {
    await formik.setFieldValue(`city_id`, value?.value ?? "");
    await formik.setFieldValue(`city`, value?.value ?? "");
    await formik.setFieldTouched("city_id");
  };
  const [isValidaCheck, setIsValidCheck] = useState(true);
  useEffect(() => {
    setIsValidCheck(true);
    setManualEntry(false);
    if (formik.values?.pincode?.toString().length == 6) {
      pincodeValidations(formik.values?.pincode);
    } else {
      formik.setFieldValue("country_id", "");
      formik.setFieldValue(`city`, "");
      formik.setFieldValue("city_id", "");
      formik.setFieldValue("state_id", "");
      formik.setFieldValue("district", "");
    }
  }, [formik.values?.pincode]);

  const pincodeValidations = async (values) => {
    setIsValidCheck(true);
    let notError = false;
    try {
      const checkPinCode = Number(values);
      const validatePinCodeUrl = `https://postcoded.in/api/get-data/${checkPinCode}`;

      const response = await axios.get(validatePinCodeUrl);
      const data = response?.data?.data;
      if (!data) {
        setIsValidCheck(true);
        return;
      }

      const cityData = data?.city_list?.map((x) => ({
        label: x?.city,
        value: x?.city,
      }));
      setCityData([...cityData]);
      await formik.setFieldValue("country_id", data?.country);
      await formik.setFieldValue("state_id", data?.state);
      await formik.setFieldValue("district", data?.district);

      if (response?.data?.folcon_engine_response === 200) {
        formik.setFieldError("pincode", "");
        setIsValidCheck(false);
        return (notError = "Success");
      }
    } catch (error) {
      if (error?.response?.data?.folcon_engine_response === 400) {
        formik.setFieldTouched("pincode", true, false);
        setIsValidCheck(true);
        formik.setFieldError("pincode", "Given Pin Code is InValid!!!");
      } else {
        formik.setFieldTouched("pincode", true, false);
        setManualEntry(true);
        formik.setFieldError(
          "pincode",
          "Service temporarily unavailable. Please enter city, state, and country manually."
        );
      }
    }
  };
  return (
    <div className="form-container">
      {activeTab === "description" && (
        <div
          className={`${" d-flex px-3"}`}
          style={{ alignItems: "center", paddingBottom: "10px" }}
        >
          <input
            className={`form-check-input mt-0 ${
              formik.errors.is_default && formik.touched.is_default
                ? "is-invalid"
                : ""
            }`}
            type="checkbox"
            checked={formik.values.is_default ? true : false}
            onChange={(e) => {
              formik.setFieldValue("is_default", e.target.checked);
            }}
            aria-describedby="invalidCheck3Feedback"
            name="is_default"
            disabled={isDisabled}
          />
          <b
            className=" d-flex login-text-primary"
            style={{
              cursor: "pointer",
              fontSize: "13px",
              color: "var( --blue-color)!important",
              paddingLeft: "10px",
            }}
          >
            Set as default
          </b>
        </div>
      )}
      {activeTab === "specification" && (
        <div className="d-flex justify-content-between">
          {mode !== "Edit" && (
            <div
              className={`${" d-flex px-3"}`}
              style={{ alignItems: "center", paddingBottom: "10px" }}
            >
              <input
                className={`form-check-input mt-0 ${
                  formik.errors.terms_agree && formik.touched.terms_agree
                    ? "is-invalid"
                    : ""
                }`}
                type="checkbox"
                // checked={formik.values.terms_agree ? true : false}
                value={isterms}
                onChange={(e) => {
                  handleBillingShippingSame(e);
                  setIsterm(true);
                }}
                aria-describedby="invalidCheck3Feedback"
                name="terms_agree"
                disabled={isDisabled}
              />
              <b
                className=" d-flex login-text-primary"
                style={{
                  cursor: "pointer",
                  fontSize: "13px",
                  color: "var( --blue-color)!important",
                  paddingLeft: "10px",
                }}
              >
                Make Billing and Shipping the Same
              </b>
            </div>
          )}
          <div
            className={`${" d-flex px-3"}`}
            style={{ alignItems: "center", paddingBottom: "10px" }}
          >
            <input
              className={`form-check-input mt-0 ${
                formik.errors.is_default && formik.touched.is_default
                  ? "is-invalid"
                  : ""
              }`}
              type="checkbox"
              checked={formik.values.is_default ? true : false}
              value={true}
              onChange={(e) => {
                formik.setFieldValue("is_default", e.target.checked);
              }}
              aria-describedby="invalidCheck3Feedback"
              name="is_default"
              disabled={isDisabled}
            />
            <b
              className=" d-flex login-text-primary"
              style={{
                cursor: "pointer",
                fontSize: "13px",
                color: "var( --blue-color)!important",
                paddingLeft: "10px",
              }}
            >
              Set as default
            </b>
          </div>
        </div>
      )}
      <h5 className="contact-heading mt-2">CONTACT DETAILS</h5>
      <div className="container px-3 py-3">
        <div className="row">
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Name
              </label>
              <input
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                className={`form-control input-with-small-placeholder ${
                  formik.errors.name && formik.touched.name ? "is-invalid" : ""
                }`}
                placeholder="Enter Name"
                type="text"
                onBlur={formik.handleBlur}
                disabled={isDisabled}
              />
              {formik.errors.name && formik.touched.name && (
                <div className="invalid-feedback">{formik.errors.name}</div>
              )}
            </div>
          </div>
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Mobile Number
              </label>
              <input
                name="mobile_no"
                value={formik.values.mobile_no}
                onChange={(e) => {
                  const value = e.target.value?.replace(/[^0-9]/g, "");
                  formik.setFieldValue("mobile_no", +value);
                }}
                placeholder="Mobile Number"
                type="text"
                onBlur={formik.handleBlur}
                className={`form-control ${
                  formik.errors.mobile_no && formik.touched.mobile_no
                    ? "is-invalid"
                    : ""
                }`}
                disabled={isDisabled}
              />
              {formik.errors.mobile_no && formik.touched.mobile_no && (
                <div className="invalid-feedback">
                  {formik.errors.mobile_no}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container px-3">
        <div className="row">
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Email Address
              </label>
              <input
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                placeholder="Email Address"
                type="email"
                onBlur={formik.handleBlur}
                className={`form-control ${
                  formik.errors.email && formik.touched.email
                    ? "is-invalid"
                    : ""
                }`}
                disabled={mode === "Edit" || isDisabled}
              />
              {formik.errors.email && formik.touched.email && (
                <div className="invalid-feedback">{formik.errors.email}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <h5 className="contact-heading my-4">
        {activeTab === "description" ? " BILLING ADDRESS" : "SHIPPING ADDRESS"}{" "}
      </h5>
      <div className="container px-3 py-2">
        <div className="row">
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Address (House No, Building, Street, Area)*
              </label>
              <input
                name="address_line_one"
                value={formik.values.address_line_one}
                onChange={(e) => {
                  const value = e.target.value?.replace(
                    /[^a-zA-Z0-9\s,.\-\/]/g,
                    ""
                  );
                  formik.setFieldValue("address_line_one", value);
                }}
                className={`form-control ${
                  formik.errors.address_line_one &&
                  formik.touched.address_line_one
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Address line one"
                type="text"
                onBlur={formik.handleBlur}
                disabled={isDisabled}
              />
              {formik.errors.address_line_one &&
                formik.touched.address_line_one && (
                  <div className="invalid-feedback">
                    {formik.errors.address_line_one}
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="container px-3 ">
        <div className="row">
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Address Line 2
              </label>
              <input
                name="address_line_two"
                value={formik.values.address_line_two}
                onChange={(e) => {
                  const value = e.target.value?.replace(
                    /[^a-zA-Z0-9\s,.-]/g,
                    ""
                  );
                  formik.setFieldValue("address_line_two", value);
                }}
                className={`form-control ${
                  formik.errors.address_line_two &&
                  formik.touched.address_line_two
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Address line two"
                type="text"
                onBlur={formik.handleBlur}
                disabled={isDisabled}
              />
              {formik.errors.address_line_two &&
                formik.touched.address_line_two && (
                  <div className="invalid-feedback">
                    {formik.errors.address_line_two}
                  </div>
                )}
            </div>
          </div>
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Pin Code*
              </label>
              <input
                name="pincode"
                value={formik.values.pincode}
                onChange={(e) => {
                  let value = e.target.value;
                  if (/^\d{0,6}$/.test(value)) {
                    formik.setFieldValue("pincode", +value);
                  }
                }}
                className={`form-control ${
                  formik.errors.pincode && formik.touched.pincode
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="pincode"
                type="text"
                onBlur={formik.handleBlur}
                disabled={isDisabled}
              />
              {formik.errors.pincode && formik.touched.pincode && (
                <div className="invalid-feedback">{formik.errors.pincode}</div>
              )}
              {pincodeValidationError && (
                <div style={{ color: "red" }}>{pincodeValidationError}</div>
              )}
            </div>
          </div>
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                Area*
              </label>
              <input
                className={`form-control mt-0 ${
                  formik.errors.area && formik.touched.area ? "is-invalid" : ""
                }`}
                type="text"
                name="area"
                placeholder="Enter Area"
                value={formik.values?.area}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.errors.area && formik.touched.area && (
                <div className="" style={{ color: "red", fontSize: "12px" }}>
                  {formik.errors.area}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container px-3 py-2">
        <div className="row">
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                {!manualEntry ? "Select City" : "Enter City"}*
              </label>
              {manualEntry ? (
                <input
                  name="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter City"
                  className={`form-control ${
                    formik.errors.city && formik.touched.city
                      ? "is-invalid"
                      : ""
                  }`}
                  disabled={isDisabled}
                />
              ) : (
                <Select
                  value={
                    cityData?.find(
                      (city) => city.value === formik.values.city
                    ) || null
                  }
                  onChange={(value) => handleCityChange(formik, value)}
                  options={cityData}
                  placeholder="Select City"
                  isClearable={true}
                  classNamePrefix="custom-select"
                  isDisabled={!formik?.values?.state_id || isDisabled}
                />
              )}
              {formik.errors.city && formik.touched.city && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {formik.errors.city}
                </div>
              )}
            </div>
          </div>
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                {!manualEntry ? "District" : "Enter District"}*
              </label>
              <input
                name="district"
                className={`form-control mt-0 ${
                  formik.errors.district && formik.touched.district
                    ? "is-invalid"
                    : ""
                }`}
                type="text"
                placeholder={!manualEntry ? "District" : "Enter District"}
                value={formik.values.district}
                onChange={formik.handleChange}
                disabled={!manualEntry || isValidaCheck}
              />
              {formik.errors.district && formik.touched.district && (
                <div className="" style={{ color: "red", fontSize: "12px" }}>
                  {formik.errors.district}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container px-3 py-2">
        <div className="row">
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                {!manualEntry ? "Country" : "Enter Country"}*
              </label>
              <input
                className={`form-control mt-0 ${
                  formik.errors.country_id && formik.touched.country_id
                    ? "is-invalid"
                    : ""
                }`}
                type="text"
                placeholder={!manualEntry ? "Country" : "Enter Country"}
                name="country_id"
                value={formik.values.country_id}
                onChange={formik.handleChange}
                disabled={!manualEntry || isValidaCheck}
              />
              {formik.errors.country_id && formik.touched.country_id && (
                <div className="" style={{ color: "red", fontSize: "12px" }}>
                  {formik.errors.country_id}
                </div>
              )}
            </div>
          </div>
          <div className="col-sm">
            <div className="m-b10">
              <label className="label-title" style={{ fontSize: "13px" }}>
                {!manualEntry ? "State" : "Enter State"}*
              </label>
              <input
                name="state_id"
                className={`form-control mt-0 ${
                  formik.errors.state_id && formik.touched.state_id
                    ? "is-invalid"
                    : ""
                }`}
                type="text"
                placeholder={!manualEntry ? "State" : "Enter State"}
                value={formik.values.state_id}
                onChange={formik.handleChange}
                disabled={!manualEntry || isValidaCheck}
              />
              {formik.errors.state_id && formik.touched.state_id && (
                <div className="" style={{ color: "red", fontSize: "12px" }}>
                  {formik.errors.state_id}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container px-3 py-2">
        <div className="row">
          <div className="col-sm">
            {activeTab !== "specification" && (
              <div className="my-4">
                <button
                  className="btn btn-primary px-4 float-end"
                  onClick={formik.handleSubmit}
                  disabled={isDisabled}
                >
                  CONTINUE <MdKeyboardDoubleArrowRight />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {activeTab === "specification" && (
        <div className="container px-3">
          <div className="row">
            <div className="col-sm">
              <button
                className="btn btn-primary px-4 w-100 my-4"
                onClick={formik.handleSubmit}
                isDisabled={isDisabled}
              >
                ADD NEW ADDRESS <MdKeyboardDoubleArrowRight />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressForm;
